import angular from 'angular';
import uiRouter from 'angular-ui-router';
import forgotPasswordComponent from './forgot-password.component';

export default
  angular.module('components.auth.forgotPassword', [
    uiRouter
  ])
    .component('forgotPassword', forgotPasswordComponent)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('forgotPassword', {
          parent: 'auth',
          url: '/forgot-password',
          params: {
            userName: null
          },
          component: 'forgotPassword',
          resolve: {
            userName: $stateParams => $stateParams.userName
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/auth/forgot-password/forgot-password.module.js